module.exports = __webpack_public_path__ + "img/form_phone.4f0da4f7.svg";